window._ = require('lodash');

import Auth from './Helpers/auth'
window.Auth = Auth // Token and User

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.interceptors.response.use(
  (response) => { return response},
  (error) => {
      if (!error.status && !error.response.data.message) {
        if (error.response.data.data === 'Unauthorized Access') {
          return Promise.reject(error);
        }
        if (error.response.status >= 500) {
          window.location.href = "../offline";
          window.location.reload();
        }
        return Promise.reject(error);
      }
      if (error.response) {
        if (error.response.data == "You can't access this switch!") {
          console.log('unaccessable');
          window.location.href = "/";
        }
        if (error.response.data.message == "Unauthenticated.") {
          console.log('Unauthenticated');
          Auth.logout();
          window.location.reload();
        }
      }
    return Promise.reject(error)
  }
);

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('Couldn\'t find the CSRF token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     wsHost: window.location.hostname,
//     wsPort: process.env.MIX_WS_PORT,
//     wssPort: process.env.MIX_WS_PORT,
//     disableStats: true,
//     encrypted: process.env.MIX_WS_SECURE == 'true' ? true : false,
//     enabledTransports: ['ws', 'wss'],
//     auth: {
//         headers: {
//             Authorization: Auth.g() ? `Bearer ${Auth.g().token}` : '',
//         },
//     },
// });
